import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';

const debounce = (func, wait) => {
  let timeout;

  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

const MitigationAmountUnitTableCell = ({ getValue, row, column, table, cell }) => {
  const columnMeta = column.columnDef.meta;
  const tableMeta = table.options.meta;
  const initialValue = getValue();
  const initialOptions = columnMeta?.options[0];
  const [value, setValue] = useState(initialValue);
  const rowMitigationLength = useMemo(() => row.getValue('proposedLength'), [row]);
  const rowMitigationWidth = useMemo(() => row.getValue('proposedWidth'), [row]);
  const rowMitigationAmountUnit = useMemo(() => row.getValue('amountUnit'), [row]);
  const debouncedUpdateRef = useRef();

  useEffect(() => {
    debouncedUpdateRef.current = debounce((newValue) => {
      if (tableMeta?.updateData) {
        tableMeta.updateData(row.index, column.id, newValue);
      }
    }, 500);
  }, [row.index, column.id, tableMeta?.updateData, columnMeta?.type, tableMeta]);

  const updateValue = useCallback((newValue) => {
    debouncedUpdateRef.current(newValue);
  }, []);

  // if both length and width default amount unit to square feet
  useEffect(() => {
    if (rowMitigationLength && rowMitigationWidth && !rowMitigationAmountUnit) {
      setValue('Square Feet');
      tableMeta?.updateData(row.index, column.id, 'Square Feet');
    }
  }, [column.id, row.index, rowMitigationAmountUnit, rowMitigationLength, rowMitigationWidth, tableMeta]);

  const handleChange = (e) => {
    setValue(e.target.value);
    updateValue(e.target.value);
  };

  return (
    <select
      aria-label={'Area Units'}
      disabled={columnMeta?.readOnly}
      id={cell.id}
      onChange={handleChange}
      required={columnMeta?.required}
      style={{ width: '100%', borderColor: 'hsl(0, 0%, 80%)' }}
      value={value ?? ''}
    >
      <option key={0} value='' className='none' style={{ display: 'none' }}>
        -- Select a value --
      </option>
      {initialOptions?.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
};

export default MitigationAmountUnitTableCell;
